import { Card, CardContent, List, ListItem, ListItemText, ListItemAvatar } from '@material-ui/core';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
// import HomeIcon from '@material-ui/icons/Home';
import { css } from '@emotion/react';

import { i18n } from 'lib/i18n';

import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
// import { colors } from 'styles/theme';
import { setOpacity } from 'styles/utils';
import { addressInit, ContactDetail } from 'lib/organization';

const cardCss = (colors: IColors) => css`
	margin-top: 13px;
	border: solid 1px ${colors.bg_border_seperator};

	&.MuiCard-root {
		box-shadow: 0 2px 22px 8px ${setOpacity(colors.bg_text_primary || '', 0.08)};
		background-color: ${colors.bg_white};
	}
`;

const contactDetailsTitleCss = (colors: IColors) => css`
	span {
		text-transform: uppercase;
		font-size: 1.4rem;
		color: ${colors.tx_text_primary};
		font-weight: bold;
	}
`;

const contactDetailsHoursCss = (colors: IColors) => css`
	li span {
		font-size: 1.4rem;
		color: ${colors.tx_text_primary};
	}

	li .MuiSvgIcon-root {
		color: ${colors.tx_text_secondary};
		width: 17px;
		height: 17px;
	}
`;

const socialMediaCss = css`
	a {
		margin-right: 25px;
	}
`;

const contactDetailsMainCss = css`
	&.MuiCardContent-root:last-child {
		padding: 16px 24px;
	}
	&.MuiCardContent-root {
		padding: 16px 24px;
	}
`;

const contactDetailsIconsCss = css`
	&.MuiListItemAvatar-root {
		min-width: 34px;
	}
`;

const ContactDetailsListItemsCss = css`
	&.MuiListItem-root {
		padding-left: 0;
	}
`;

interface ContactProps {
	contactData: ContactDetail;
}

const ContactDetails = (props: ContactProps) => {
	const {
		email,
		phoneNumber,
		// website,
		facebook,
		twitter,
		instagram,
	} = props.contactData;
	const { city, street, streetNum, state } = props.contactData?.address ?? addressInit;

	const { colors } = useColors();
	return (
		<Card css={cardCss(colors)}>
			<CardContent css={contactDetailsMainCss}>
				<List css={contactDetailsHoursCss(colors)}>
					<ListItem css={ContactDetailsListItemsCss}>
						<ListItemText css={contactDetailsTitleCss(colors)}>{i18n.contact.contactDetailsTitle}</ListItemText>
					</ListItem>

					{email && (
						<ListItem css={ContactDetailsListItemsCss}>
							<ListItemAvatar css={contactDetailsIconsCss}>
								<MailOutlineIcon />
							</ListItemAvatar>
							<ListItemText>
								<a  data-testid="ContactDetails-34F1CF" target="_blank" rel="noreferrer" href={`mailto:${email}`}>
									{email}
								</a>
							</ListItemText>
						</ListItem>
					)}

					{state && (
						<ListItem css={ContactDetailsListItemsCss}>
							<ListItemAvatar css={contactDetailsIconsCss}>
								<LocationOnIcon />
							</ListItemAvatar>
							<ListItemText>{`${streetNum ?? ''} ${street ?? ''}, ${city ?? ''}, ${state ?? ''}`}</ListItemText>
						</ListItem>
					)}

					{phoneNumber && (
						<ListItem css={ContactDetailsListItemsCss}>
							<ListItemAvatar css={contactDetailsIconsCss}>
								<WhatsAppIcon />
							</ListItemAvatar>
							<ListItemText>
								<a  data-testid="ContactDetails-8306ED" target="_blank" rel="noreferrer" href={`https://wa.me/${phoneNumber}`}>
									{phoneNumber}
								</a>
							</ListItemText>
						</ListItem>
					)}
					{/*  {website && (
            <ListItem css={ContactDetailsListItemsCss}>
              <ListItemAvatar css={contactDetailsIconsCss}>
                <HomeIcon />
              </ListItemAvatar>
              <a  data-testid="ContactDetails-86D834" target="_blank" rel="noreferrer" href={website}>
                <ListItemText>{website}</ListItemText>
              </a>
            </ListItem>
        )} */}
				</List>

				<div css={socialMediaCss}>
					{facebook && (
						<a  data-testid="ContactDetails-C86C29" target="_blank" rel="noreferrer" href={facebook}>
							<FacebookIcon />
						</a>
					)}

					{twitter && (
						<a  data-testid="ContactDetails-43916C" target="_blank" rel="noreferrer" href={twitter}>
							<TwitterIcon />
						</a>
					)}

					{instagram && (
						<a  data-testid="ContactDetails-69F668" target="_blank" rel="noreferrer" href={instagram}>
							<InstagramIcon />
						</a>
					)}
				</div>
			</CardContent>
		</Card>
	);
};

export default ContactDetails;
